const Home = () => import('@/pages/home/index.vue')
const Blog = () => import('@/pages/blog/index.vue')
const Fund = () => import('@/pages/fund/index.vue')
const History = () => import('@/pages/history/index.vue')
const About = () => import('@/pages/aboutUs/index.vue')
const Awards = () => import('@/pages/awards/index.vue')
const Duty = () => import('@/pages/duty/index.vue')

const routes = [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/blog',
      name: 'blog',
      component: Blog,
    },
    {
      path: '/fund',
      name: 'fund',
      component: Fund,
    },
    {
      path: '/history',
      name: 'history',
      component: History,
    },
    {
      path: '/about',
      name: 'aboutUs',
      component: About,
    },
    {
      path: '/awards',
      name: 'awards',
      component: Awards,
    },
    {
      path: '/duty',
      name: 'duty',
      component: Duty,
    },
]
export default routes
